import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { useEffect } from "react";
import { DefaultStyled } from "./Default.style";
var Default = function(param) {
    var story = param.story, action = param.action;
    useEffect(function() {
        action("play");
    }, [
        story
    ]);
    return /*#__PURE__*/ _jsx(DefaultStyled, {
        className: "storyContent",
        children: /*#__PURE__*/ _jsx("p", {
            className: "text",
            children: "This story could not be loaded."
        })
    });
};
export var tester = function() {
    return {
        condition: true,
        priority: 1
    };
};
export default {
    renderer: Default,
    tester: tester
};
